class SupportPresenter {
  constructor(view, findUseCase) {
    this.view = view;
    this.findUseCase = findUseCase;
    this.limit = 10;
    this.current = 1;
    this.where = {
      status: "open",
    };
    this.documents = [];
  }

  componentDidMount() {
    this.getData();
  }

  // getData() {
  //   const skip = (this.current - 1) * this.limit;
  //   const query = {
  //     count: true,
  //     limit: 20,
  //     skip,
  //     sort: { createdAt: -1 },
  //     where: this.where,
  //     include: ["all", "creator.department"],
  //   };
  //   console.log("qqq", query);
  //   this.view.showProgress();
  //   this.findUseCase
  //     .execute("tickets", query)
  //     .then(({ count, objects }) => {
  //       this.documents = this.documents.concat(objects);
  //       this.view.setCount(count);
  //       console.log("document", this.documents);

  //       this.view.setTickets(this.documents);
  //       this.view.hideProgress();
  //     })
  //     .catch((error) => {
  //       this.view.hideProgress();
  //       this.view.showError(error);
  //     });
  // }

  async getData() {
    // init (once) a simple cache for department names
    this.depCache = this.depCache || new Map(); // Map<departmentId, departmentName>

    const skip = (this.current - 1) * this.limit;
    const query = {
      count: true,
      limit: 20,
      skip,
      sort: { createdAt: -1 },
      where: this.where,
      include: ["all", "creator.department"],
    };

    this.view.showProgress();
    try {
      const { count, objects } = await this.findUseCase.execute(
        "tickets",
        query
      );

      // 1) Collect unique department IDs we don't have cached yet
      const neededIds = Array.from(
        new Set(
          (objects || [])
            .map((o) => o?.creator?.department?.id)
            .filter(Boolean)
            .filter((id) => !this.depCache.has(id))
        )
      );

      // 2) Batch fetch missing departments and fill the cache
      if (neededIds.length) {
        const depResp = await this.findUseCase.execute("departments", {
          where: { id: neededIds },
          limit: neededIds.length,
          include: ["all"],
        });

        const deps = depResp?.objects || depResp || [];
        for (const d of deps) {
          this.depCache.set(d.id, d.name || null);
        }
        // Cache null for any IDs not returned to avoid refetching on next pages
        for (const id of neededIds) {
          if (!this.depCache.has(id)) this.depCache.set(id, null);
        }
      }

      // 3) Enrich each ticket with creatorDep (department name)
      const enriched = (objects || []).map((o) => {
        const depId = o?.creator?.department?.id;
        const creatorDep = depId ? this.depCache.get(depId) ?? null : null;
        return { ...o, creatorDep };
      });

      // 4) Append to running list, update view
      this.documents = this.documents.concat(enriched);
      this.view.setCount(count);
      this.view.setTickets(this.documents);
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.view.hideProgress();
    }
  }

  onClickOpened() {
    this.where.status = "open";
    this.documents = [];
    this.getData();
  }

  onCLickClosed() {
    this.where.status = "closed";
    this.documents = [];
    this.getData();
  }

  onClickTicket(chat) {
    this.view.navigateTo("/support/chat", chat);
  }

  loadMore() {
    if (!this.view.state.progress) {
      this.current++;
      this.getData();
    }
  }

  onSubmitSearch(word) {
    this.where.id = { $regex: word.toLowerCase() };

    this.documents = [];
    this.current = 1;
    this.getData();
  }

  onChangeDate(where) {
    this.where.createdAt = where.createdAt;
    this.documents = [];
    this.current = 1;
    this.getData();
  }

  onClickExport() {
    this.view.exportPDF();
  }
}

export default SupportPresenter;
